import { render } from "./Time.vue?vue&type=template&id=dd1ce7a2&lang=pug"
import script from "./Time.vue?vue&type=script&lang=ts"
export * from "./Time.vue?vue&type=script&lang=ts"
script.render = render

export default script